/**
 * The API key we bind the electron desktop app context bridge API to, accessible on window[apiKey] in ftr-web
 * See: https://www.electronjs.org/docs/latest/api/context-bridge#contextbridgeexposeinmainworldapikey-api
 */
export const ELECTRON_API_KEY = 'FTRDesktopBridge';
